module.exports = __webpack_public_path__ + "img/logo-ageng.3a0bb4ad.png";